import React, { useContext, useEffect, useState } from "react";

import TranslationKeysLeftPanel from "../../components/translation-keys-left-panel/translation-keys-left-panel.component";
import useGetKeys from "../../api/keys";
import TranslationKeysRightPanel from "../../components/translation-keys-right-panel/translation-keys-right-panel.component";
import KeysTranslationItem from '../../components/keys-translation-item/keys-translation-item.component';

import './translation-keys-page.styles.scss';
import { Context } from "../../state/context";
import { KEY_STATUS } from "../../enums/key-status";



export default function TranslationKeysPage() {
    const { state, dispatch } = useContext(Context);
    const [allKeys, setAllKeys] = useState([]);
    const [activeTranslationKey, setActiveTranslationKey] = useState(false);
    const [activeKeyText, setActiveKeyText] = useState("");

    const getKeys = useGetKeys();

    useEffect(() => {
        (async () => {
            const keys = await getKeys('en', KEY_STATUS.PUBLISHED);
            setAllKeys(keys);
            dispatch({type: 'SET_ACTIVE_TRANSLATION_KEY', activeTranslationKey: keys[0]});
            dispatch({type: 'SET_KEYS', keys});
        })();
    }, []);

    useEffect(() => {
        setActiveKeyText(state.activeKey.text);
    }, [state.activeKey]);

    useEffect(() => {
        setActiveTranslationKey(state.activeTranslationKey);
    }, [state.activeTranslationKey]);

    return (
        <div className={"container-fluid"}>
            <div className="row mt-4 key-columns">
                <TranslationKeysLeftPanel keys={allKeys} />
                {activeTranslationKey && <TranslationKeysRightPanel />}
                {activeKeyText && <KeysTranslationItem key={state.activeKey.id} item={{
                    key: state.activeKey
                }} />}
            </div>
        </div>
    )
}
